import axios from 'axios';
import _ from 'lodash';
import {message} from 'antd';

const INVALID_TOKEN_MESSAGE = 'Invalid token or expired token.';
let isAuthRedirecting = false;

export function clearToken(){
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
}

function isInvalidOrExpiredToken(response) {
    const status = response?.status;
    const data = response?.data;
    const detail = data?.detail;

    return (
        status === 401 ||
        detail === INVALID_TOKEN_MESSAGE
    );
}

function redirectToSignin() {
    clearToken();
    if (!isAuthRedirecting && window.location.pathname !== '/signin') {
        isAuthRedirecting = true;
        window.location.replace('/signin');
    }
}

const getToken = () => {
    try {
        const idToken = localStorage.getItem('token');
        return idToken;
    } catch (err) {
        // clearToken();
        return new Map();
    }
}

const getCurrentUser = () => {
    try {
    const currentUser = localStorage.getItem('currentUser');
    if (!currentUser || currentUser === 'undefined') {
        clearToken();
        return new Map();
    }
    return new Map({ currentUser: JSON.parse(currentUser) });
    } catch (err) {
    // clearToken();
    return new Map();
    }
}

export function setToken(token, user) {
    const currentUser = user?.user ?? user;
    if (currentUser) {
        localStorage.setItem("currentUser", JSON.stringify(currentUser));
    } else {
        localStorage.removeItem("currentUser");
    }
    localStorage.setItem("token", token);
}
  
export function get(path, options) {
    options = options || {auth: true};
    let config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    if(options.auth == false){}else{
        const jwt = "Bearer " + getToken();
        config.headers['x-access-token'] = "1";
        config.headers['Authorization'] = jwt;
    }

    return axios.get(path, config)
            .then((result) => {
                return result.data;
            })
            .catch((error) => {
                if (error.response){
                    let {response} = error;
                    let {data} = response;
                    let {detail} = data;

                    if (isInvalidOrExpiredToken(response)) {
                        redirectToSignin();
                        return {ok: false, errors: []};
                    }

                    if (response?.status === 403 && detail) {
                        const detailMessage = typeof detail === 'string' ? detail : (detail?.message || 'No tienes permisos para esta acción');
                        message.warning(detailMessage);
                        return {ok: false, errors: [{msg: detailMessage}], raw: data};
                    }

                    if (data?.ok === false) {
                        message.error(data.message);
                        return {ok: false, errors: [{msg: data.message}], raw: data};
                    }

                    if (detail?.ok == false) {
                        message.error(detail.message);
                        return {ok: false, errors: [{msg: detail.message}], raw: detail};
                    }
                    return {ok: false, errors: detail || data}; 
                }else if(error.request){
                    return {ok: false, errors: error.request};
                }else if(error.message){
                    return {ok: false, errors: error.message};
                }
            });
}

export function post(path, payload, options) {
    options = options || {auth: true};
    let config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    if(options.auth == false){}else{
        const jwt = "Bearer " + getToken();
        config.headers['x-access-token'] = "1";
        config.headers['Authorization'] = jwt;
    }

    return axios.post(path, payload, config)
            .then((result) => {
                return result.data;
            })
            .catch((error) => {
                if (error.response){
                    let {response} = error;
                    let {data} = response;
                    if (isInvalidOrExpiredToken(response)) {
                        redirectToSignin();
                        return {ok: false, errors: []};
                    }
                    if (response?.status === 403) {
                        const detail = data?.detail;
                        const detailMessage = typeof detail === 'string' ? detail : (detail?.message || 'No tienes permisos para esta acción');
                        message.warning(detailMessage);
                        return {ok: false, errors: [{msg: detailMessage}], raw: data};
                    }
                    if (data?.ok == false) {
                        message.error(data.message);
                        return {ok: false, errors: [{msg: data.message}]};
                    }
                    return {ok: false, errors: data}; 
                }else if(error.request){
                    return {ok: false, errors: error.request};
                }else if(error.message){
                    return {ok: false, errors: error.message};
                }
            });
}

export function put(path, payload, options) {
    options = options || {auth: true};
    let config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    if(options.auth == false){}else{
        const jwt = "Bearer " + getToken();
        config.headers['x-access-token'] = "1";
        config.headers['Authorization'] = jwt;
    }

    return axios.put(path, payload, config)
            .then((result) => {
                return result.data;
            })
            .catch((error) => {
                if (error.response){
                    let {response} = error;
                    let {data} = response;
                    if (isInvalidOrExpiredToken(response)) {
                        redirectToSignin();
                        return {ok: false, errors: []};
                    }
                    if (response?.status === 403) {
                        const detail = data?.detail;
                        const detailMessage = typeof detail === 'string' ? detail : (detail?.message || 'No tienes permisos para esta acción');
                        message.warning(detailMessage);
                        return {ok: false, errors: [{msg: detailMessage}], raw: data};
                    }
                    if (data?.ok == false) {
                        message.error(data.message);
                        return {ok: false, errors: [{msg: data.message}]};
                    }
                    return {ok: false, errors: data}; 
                }else if(error.request){
                    return {ok: false, errors: error.request};
                }else if(error.message){
                    return {ok: false, errors: error.message};
                }
            });
}

export function _delete(path, options) {
    options = options || {auth: true};
    let config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    if(options.auth == false){

    }else{
        const jwt = "Bearer " + getToken();
        config.headers['x-access-token'] = "1";
        config.headers['Authorization'] = jwt;
    }

    return axios.delete(path, config)
            .then((result) => {
                return result.data;
            })
            .catch((error) => {
                if (error.response){
                    let {response} = error;
                    let {data} = response;
                    if (isInvalidOrExpiredToken(response)) {
                        redirectToSignin();
                        return {ok: false, errors: []};
                    }
                    if (response?.status === 403) {
                        const detail = data?.detail;
                        const detailMessage = typeof detail === 'string' ? detail : (detail?.message || 'No tienes permisos para esta acción');
                        message.warning(detailMessage);
                        return {ok: false, errors: [{msg: detailMessage}], raw: data};
                    }
                    if (data?.ok == false) {
                        message.error(data.message);
                        return {ok: false, errors: [{msg: data.message}]};
                    }
                    return {ok: false, errors: data}; 
                }else if(error.request){
                    return {ok: false, errors: error.request};
                }else if(error.message){
                    return {ok: false, errors: error.message};
                }
            });
}

export function patch(path, payload, options) {
    options = options || { auth: true };
    let config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    if (options.auth !== false) {
        const jwt = "Bearer " + getToken();
        config.headers['x-access-token'] = "1";
        config.headers['Authorization'] = jwt;
    }

    return axios.patch(path, payload, config)
        .then((result) => {
            return result.data;
        })
        .catch((error) => {
            if (error.response) {
                let { response } = error;
                let { data } = response;
                if (isInvalidOrExpiredToken(response)) {
                    redirectToSignin();
                    return {ok: false, errors: []};
                }
                if (response?.status === 403) {
                    const detail = data?.detail;
                    const detailMessage = typeof detail === 'string' ? detail : (detail?.message || 'No tienes permisos para esta acción');
                    message.warning(detailMessage);
                    return { ok: false, errors: [{ msg: detailMessage }], raw: data };
                }
                if (data?.ok === false) {
                    message.error(data.message);
                    return { ok: false, errors: [{ msg: data.message }] };
                }
                return { ok: false, errors: data };
            } else if (error.request) {
                return { ok: false, errors: error.request };
            } else if (error.message) {
                return { ok: false, errors: error.message };
            }
        });
}

export function upload(path, payload, options){
    options = options || {};

    let config = {
        headers: {
            'Content-Type': `multipart/form-data;`,
        },
    };

    if(options.auth == false){}else{
        const jwt = "Bearer " + getToken();
        config.headers['x-access-token'] = "1";
        config.headers['Authorization'] = jwt;
    }

    return axios.post(path, payload, config)
                .then((result) => {
                    return result.data;
                })
                .catch((error) => {
                    if (error.response){
                        let {response} = error;
                        let {data} = response;
                        if (isInvalidOrExpiredToken(response)) {
                            redirectToSignin();
                            return {ok: false, errors: []};
                        }
    
                        if (data?.ok == false) {
                            message.error(data.message);
                            return {ok: false, errors: [{msg: data.message}]};
                        }
                        return {ok: false, errors: data}; 
                    }else if(error.request){
                        return {ok: false, errors: error.request};
                    }else if(error.message){
                        return {ok: false, errors: error.message};
                    }
                });
}

export async function downloadFile(path, filename, options) {
    try {
        options = options || {auth: true};
        let config = {
            headers: {
                'Content-Type': 'application/octet-stream',
            },
        };

        if(options.auth == false){}else{
            const jwt = "Bearer " + getToken();
            config.headers['x-access-token'] = "";
            config.headers['Authorization'] = jwt;
        }
        config.responseType = 'blob';
        const response = await axios.get(path, config);

        if(!filename){
            // Extraer el header Content-Disposition
            const contentDisposition = response.headers["content-disposition"];
            const fileNameMatch = contentDisposition?.match(/filename="?(.+?)"?$/);
            if (fileNameMatch && fileNameMatch.length > 1) {
                filename = fileNameMatch[1];
            }
        }

        // Crear una URL para el blob recibido
        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Crear un enlace para la descarga
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // Nombre del archivo

        // Agregar el enlace al documento y hacer clic automáticamente
        document.body.appendChild(link);
        link.click();

        // Limpiar la URL creada
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error al descargar el archivo:', error);
    }
}


